import { render } from "./VuexPlayground.vue?vue&type=template&id=0598c998"
import script from "./VuexPlayground.vue?vue&type=script&lang=js"
export * from "./VuexPlayground.vue?vue&type=script&lang=js"
script.render = render

export default script